/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ElementFromJSON, ElementToJSON, PresentationFromJSON, PresentationToJSON, } from './';
export function TutorialElementFromJSON(json) {
    return TutorialElementFromJSONTyped(json, false);
}
export function TutorialElementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'element': !exists(json, 'element') ? undefined : ElementFromJSON(json['element']),
        'presentations': !exists(json, 'presentations') ? undefined : (json['presentations'].map(PresentationFromJSON)),
    };
}
export function TutorialElementToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'element': ElementToJSON(value.element),
        'presentations': value.presentations === undefined ? undefined : (value.presentations.map(PresentationToJSON)),
    };
}
//# sourceMappingURL=TutorialElement.js.map